/**
 * Shorten main top level folders to just their first letter,
 * eg 'app/src/foo' => 'a/foo'
 */
function getShortenFileName(topLevelFolders: string[]) {
  return (fileNameRaw?: string) =>
    topLevelFolders.reduce((fileName: string, topLevelFolder) => {
      if (topLevelFolder !== '' && fileName.startsWith(topLevelFolder)) {
        if (topLevelFolder.startsWith('../')) {
          const startIndex = topLevelFolder.search(/[^./]/);
          return fileName.replace(topLevelFolder, `/${topLevelFolder[startIndex]}`);
        }
        return fileName.replace(topLevelFolder, topLevelFolder[0]);
      }
      return fileName;
    }, fileNameRaw || '');
}

export default getShortenFileName;
